import React from 'react'
import PropTypes from 'prop-types'
import {
	DragSource,
} from 'react-dnd';
import Card from './Card';

export const TYPE = {
	BOX: 'box',
	CARD: 'card'
}

const boxSource = {
	beginDrag(props) {
		return {
			id: props.event.id,
		}
	},

	endDrag(props, monitor) {
		const item = monitor.getItem()
		const dropResult = monitor.getDropResult()

		if (dropResult && props.onChange) {
			props.onChange(item.id)
		}
	},
}

export class Box extends React.Component {
	static propTypes = {
		connectDragSource: PropTypes.func.isRequired,
		isDragging: PropTypes.bool.isRequired,
		event: PropTypes.object.isRequired,
	}

	render() {
		const { isDragging, connectDragSource } = this.props
		const opacity = isDragging ? 0.4 : 1

		return (
			connectDragSource &&
			connectDragSource(
			<div className="ant-col-xs-24 ant-col-sm-24 ant-col-md-12 ant-col-lg-12 ant-col-xl-6" style={{ opacity, marginTop: '50px', display:'flex', justifyContent:'center' }} >
				<Card event={this.props.event}/>
			</div>)
		)
	}
}

export default DragSource(
	TYPE.BOX,
	boxSource,
	(connect, monitor) => ({
		connectDragSource: connect.dragSource(),
		isDragging: monitor.isDragging(),
	}),
)(Box)


// WEBPACK FOOTER //
// ./src/features/admin/events/item/CardDND.js